module.exports = __webpack_public_path__ + "img/paamon_no.16349db0.png";